
import navigation from "../data/navigation.json";
import global from "../data/global.json";


let allSceneJsonFiles = (ctx => {
  let keys = ctx.keys();
  let values = keys.map(ctx);
  return keys.reduce((o, k, i) => { o[k] = values[i]; return o; }, {});
})(require.context('../data/scenes', true, /.json/));


let sceneObjects = Object.keys(allSceneJsonFiles).reduce((acc, key) => {
  let newName =  key.slice(2).slice(0,-5);
  acc[newName] = allSceneJsonFiles[key];
  return acc;
}, {});


const defaultScene = sceneObjects[navigation.children.find(x=>x.url === global.defaultScene).children[0].url];


const cleanScenePath = (location) => {
  let cleanPath = location.pathname;
  cleanPath = cleanPath.replace(window.public_url, "");
  return cleanPath
}

const locationScene = loadSceneByPathname(cleanScenePath(window.location));



let initialState = {
  current: locationScene,
  activeHotspotId: undefined
};


function loadSceneByPathname(pathname){

  let parts = pathname.split("/").filter(Boolean);
  let level1 =  parts.length > 0  ? parts[0] : undefined;
  let level2 = parts.length > 1 ? parts[1] : undefined;

  if(!level1) {
    return defaultScene;
  }

  if(level1) {
    let level1Scene = navigation.children.find(x => x.url === level1);
    if (level1Scene) {
      if(level1Scene.comingSoon){
        return defaultScene;
      }
      level2 = level2 === "unlock" ? undefined : level2;
      level2 = !level2 ? level1Scene.children[0].url : level2;
      return sceneObjects[level2]
    }
  }
}


export default function(state = initialState, action){

  switch(action.type){

    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        current: loadSceneByPathname(action.payload.location.pathname),
        activeHotspotId: undefined
      };

    case "scene/ACTIVATE_HOTSPOT":
      return {
        ...state,
        activeHotspotId: action.payload
      };

    // case "step/NEXT":
    case "step/FINISH":
      return {
        ...state,
        activeHotspotId: undefined
      };

    default: return state;
  }

}


// WEBPACK FOOTER //
// ./src/reducers/scene.js